/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class FormError extends PureComponent {
  /**
   * Set PropTypes for this component.
   * @type {object}
   */
  static propTypes = {
    errorMessage: PropTypes.string.isRequired,
  };

  render() {
    const {
      errorMessage,
    } = this.props;

    return (
      <span
        className="error-msg newsletters__error-msg"
      >
        {errorMessage}
      </span>
    );
  }
}
